import { render, staticRenderFns } from "./addView.vue?vue&type=template&id=24e4b44e&scoped=true"
import script from "./addView.vue?vue&type=script&lang=js"
export * from "./addView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e4b44e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e4b44e')) {
      api.createRecord('24e4b44e', component.options)
    } else {
      api.reload('24e4b44e', component.options)
    }
    module.hot.accept("./addView.vue?vue&type=template&id=24e4b44e&scoped=true", function () {
      api.rerender('24e4b44e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Operations/staffManage/addView.vue"
export default component.exports